
import React, { useState } from "react";
import "./ibsupstyles.css";
import compLogo from './CA-Markets-Global-Logo-Colour-02.png'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SignatureCanvas from "react-signature-canvas";
import moment from 'moment-timezone';
import axios from 'axios';
import { ulid } from 'ulid';
const Input = ({ label, id, handleChange, name, type }) => (

    <>
        <div >
            <label htmlFor={id}>{label}</label>
            <input style={{ width: '150px', height: '40', fontSize: '15px', }} type={type || 'text'} id={id} name={name || id} onChange={handleChange} />
        </div>
        <br />
    </>
);

export default function Ibsupplemental() {
    let sign_base64
    const [sign, setSign] = useState();
    const [url, setUrl] = useState(null); // create a state that will contain our image url
    const [form, setFormValue] = useState({ fe_en: 0, ex_fe_en: 0, metal: 0, ex_metal: 0, crypto_diff: 0, ex_crypto_diff: 0, index_diff_contr: 0, ex_index_diff_contr: 0, name: '', email: '', form_data: '', form_name: '代理返佣政策20241021', date: moment().tz('Asia/Shanghai').format(), id: ulid() });
    const [addnew, setAdd] = useState(false)

    const printDocument = () => {
        const input = document.getElementById("divToPrint");
        html2canvas(input).then((canvas) => {
            document.body.appendChild(canvas);
            var imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
            //pdf.output('dataurlnewwindow');
            pdf.save("代理返佣政策.pdf");
        });
    };

    const handleClear = () => {
        sign.clear()
    }

    async function fetchAdd() {

        var data = {
            "id": form.id,
            "full_name": form.name,
            "email": form.email,
            "form_name": form.form_name,
            "sign_base64": sign_base64,
            "date_create": form.date,
            "date_update": form.date,
            "form_data": JSON.stringify(form),
            "doc_status": "pending",
            "client_type": "partner"
        }

        var res = await axios.post(`https://51z378kvpi.execute-api.ap-east-1.amazonaws.com/prod/add?method=add`, JSON.stringify(data))
        return res
    }
    async function fetchUpdate() {

        var data = {
            "id": form.id,
            "full_name": form.name,
            "email": form.email,
            "form_name": form.form_name,
            "sign_base64": sign_base64,
            "date_create": form.date,
            "form_data": JSON.stringify(form),
            "doc_status": "pending",
            "client_type": "partner"
        }
        var res = await axios.post(`https://51z378kvpi.execute-api.ap-east-1.amazonaws.com/prod/add?method=update`, JSON.stringify(data))
        return res
    }

    async function handleGenerate() {
        setUrl(sign.getTrimmedCanvas().toDataURL('image/png'))
        sign_base64 = sign.getTrimmedCanvas().toDataURL('image/png')
        console.log(addnew)
        if (addnew) {
            var res = await fetchUpdate();
            //setFormValue({'date': moment().tz('Asia/Shanghai').format()})
            console.log(res)
            if (res.data.message === 'success') {
                alert('文档更新成功')

            } else {
                alert('文档更新失敗，請重試')

            }

        } else {

            var res = await fetchAdd();
            //setFormValue({'date': moment().tz('Asia/Shanghai').format()})
            console.log(res)
            if (res.data.message === 'success') {
                setAdd(true)
                alert('文档上存成功', addnew)

            } else {
                alert('文档上存失敗，請重試')

            }
        }
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFormValue(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

    //  <div><a href="https://main.d2tj8hhau2jhnr.amplifyapp.com/"><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48" ></img></a></div>

    return (

        <div className="grid gap-8">

            <div className="flex-container justify-self-center">

                <div style={{
                    backgroundColor: "#f5f5f5",
                    width: "210mm",
                    minHeight: "297mm",

                }}>
                    <div>





                    </div>
                    <div >
                        <h1 className="mt-10 text-center" >代理佣金附件：代理返佣政策</h1>

                        <h4 className=" mt-10 mb-10 text-1xl font-medium text-center" >请填写正确资料并签署</h4>
                        <div className="sm:justify-self-center">

                            <div className="md:justify-self-center">
                                <Input label="代理全名： " id="name" handleChange={handleChange} />
                            </div>

                            <div className="md:justify-self-center">
                                <Input label="电邮地址： " id="email" handleChange={handleChange} />
                            </div>








                            <div className="md:justify-self-center">

                            


                                <div className="md:justify-self-center max-w-5xl rounded overflow-hidden shadow-lg">
                                    <div className="px-2 py-4 ">
                                        <div className="font-bold text-xl mb-2">标准账户</div>
                                        <Input label="外汇&能源: 点/标准手 " id="fe_en" handleChange={handleChange} />
                                        <Input label="贵金属: 点/标准手 " id="metal" handleChange={handleChange} />
                                        <Input label="加密货币差价合约: 点/标准手" id="crypto_diff" handleChange={handleChange} />
                                        <Input label="指数差价合约&期货: 点/标准手 " id="index_diff_contr" handleChange={handleChange} />
                                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                    </div>
                                </div>
                                <div className="md:justify-self-center max-w-5xl rounded overflow-hidden shadow-lg">
                                    <div className="px-2 py-4">
                                        <div className="font-bold text-xl mb-2">额外加佣（非必填项）</div>
                                        <Input label="外汇&能源: 点/美金 " id="ex_fe_en" handleChange={handleChange} />
                                        <Input label="贵金属: 点/美金" id="ex_metal" handleChange={handleChange} />
                                        <Input label="加密货币差价合约: " id="ex_crypto_diff" handleChange={handleChange} />
                                        <Input label="指数差价合约&期货: 点/美金 " id="ex_index_diff_contr" handleChange={handleChange} />
                                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>

                                    </div>


                                </div>
                                
                            </div>
                        </div>
                        <br />
                        <br />
                        <div>
                            <div className=" justify-self-center">客户签署： (请在框内签名)</div>
                            <div>
                                <div className="justify-self-center border border-blue-500 rounded" style={{ width: 350, height: 150, }}>
                                    <SignatureCanvas canvasProps={{ width: 349, height: 149, className: 'sigCanvas' }}
                                        ref={data => setSign(data)}
                                    />
                                </div>
                                <div className="justify-self-center" style={{ paddingTop: '5px', padding: '5px', }}>
                                    <button class='ml-1 button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => handleClear()}>清除</button>
                                    <button class='ml-1 button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => handleGenerate()}>保存资料及签名</button>
                                    <button class='ml-1 button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded' onClick={() => printDocument()}>下载协议</button>
                                </div>
                            </div>
                            <div className="mt-5 mb-2 justify-self-center max-w-sm rounded overflow-hidden shadow-lg">
                            <div className="px-2 py-4">
                                <p className="mb-2">使用说明：</p>
                                <p className="ml-5 mb-2">1. 如需重新签署，请点击"清除"按钮。</p>
                                <p class="ml-5 mb-2 break-words">2. 填写资料并完成签名后，点击"保存资料及签署"按钮确认。您的签名将显示在右侧协议中。</p>
                                <p className="ml-5 mb-2"></p>
                                <p className="ml-5 mb-2">3. 点击"下载协议"按钮将已签署的协议保存至您的设备。</p>
                                <p className="ml-5 mb-2">4. 点击<a href="https://main.d2tj8hhau2jhnr.amplifyapp.com/" class='button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-1 px-5 hover:border-transparent rounded'>这里</a>返回协议主頁。</p>
                            </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
            <div className="flex-container justify-self-center">


                <div>
                    <div>
                        <div id="divToPrint">

                            <div style={{
                                backgroundColor: "#f5f5f5",
                                width: "210mm",
                                minHeight: "297mm",

                            }}>
                                <div className="ml-10"><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48" /></div>
                                <div className="text-center mt-5" >代理佣金附件：代理返佣政策 （标准账户）</div>
                                <div className="content">
                                    <div className="mt-10">CA 同意按照 IB 协议在标准账户中支付如下内返和佣金结构：</div>
                                    <br />
                                    <div className="pt-5 mb-3"><b><u>1. 标准账户内返：</u></b></div>
                                    <div className="">
                                    <table className="table-auto border border-bottom border-black ">
                                        <thead className="bg-blue-500 text-black">
                                            <tr>
                                                <th class="py-2 md:px-20">交易品种</th>
                                                <th class="py-2 md:px-20">内返</th>
                                                <th class="py-2 md:px-10">手</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="px-2 py-4">外汇&能源</td>
                                                <td class="px-6 py-4">{form.fe_en} 点</td>
                                                <td class="px-2 py-4">标准手</td>
                                            </tr>
                                            <tr class="active-row">
                                                <td class="px-2 py-4">贵金属</td>
                                                <td class="px-6 py-4"> {form.metal} 点</td>
                                                <td class="px-2 py-4">标准手</td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 py-4">加密货币差价合约</td>
                                                <td class="px-6 py-4">{form.crypto_diff} 点</td>
                                                <td class="px-2 py-4">标准手</td>
                                            </tr>
                                            <tr class="active-row">
                                                <td class="px-2 py-4">指数差价合约&期货</td>
                                                <td class="px-6 py-4">{form.index_diff_contr} 点</td>
                                                <td class="px-2 py-4">标准手</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <div className="pt-10 mb-3"> <b><u>2. 额外加佣（非必填项）：</u></b></div>
                                    <div className="">
                                    <table className=" table-auto border border-bottom border-black">
                                        <thead className="bg-blue-500 text-black">
                                            <tr>
                                                <th class="py-2 md:px-20">交易品种</th>
                                                <th class="py-2 md:px-20">加点</th>
                                                <th class="py-2 md:px-10"> 加 佣 金 </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="px-2 py-4">外汇&能源</td>
                                                <td class="px-6 py-4"> {form.ex_fe_en} 点</td>
                                                <td class="px-2 py-4">美金</td>
                                            </tr>
                                            <tr class="active-row">
                                                <td class="px-2 py-4">贵金属</td>
                                                <td class="px-6 py-4"> {form.ex_metal} 点</td>
                                                <td class="px-2 py-4">美金</td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 py-4">加密货币差价合约</td>
                                                <td class="px-2 py-4">暂无加点</td>
                                                <td class="px-2 py-4">暂无加佣</td>
                                            </tr>
                                            <tr class="active-row">
                                                <td class="px-2 py-4">指数差价合约&期货</td>
                                                <td class="px-6 py-4"> {form.ex_index_diff_contr} 点</td>
                                                <td class="px-2 py-4">美金</td>
                                            </tr>
                                        </tbody>
                                    </table>
                            </div>
                                    <div className="mt-5">
                                        <div>代理全名： {form.name}</div>
                                        <div>电邮地址： {form.email}</div>
                                        <div>签署日期：{form.date}</div>
                                        <div>签署</div>
                                        <br />
                                        <br />
                                        <img src={url} alt="" />

                                        <br />
                                        <br />

                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <div className="version"> 文档版本： {form.form_name} </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>


        </div >



    );
}


